// Currency formatting utility that respects user's currency preference
export const formatCurrency = (amount, currencyCode = 'USD', locale = 'en-US') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0.00';
  }

  // Currency symbol mapping
  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    NGN: '₦',
    GHS: '₵',
    KES: 'KSh',
    ZAR: 'R',
    CAD: 'C$',
    AUD: 'A$',
    JPY: '¥',
    CHF: 'CHF',
    CNY: '¥',
    INR: '₹',
    BRL: 'R$',
    MXN: '$'
  };

  try {
    // Use Intl.NumberFormat for proper currency formatting
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (error) {
    // Fallback to simple formatting with currency symbol
    const symbol = currencySymbols[currencyCode] || currencyCode;
    const formattedAmount = Math.abs(amount).toFixed(2);
    return `${symbol}${formattedAmount}`;
  }
};

// Format amount without currency symbol (just the number)
export const formatAmount = (amount, currencyCode = 'USD', locale = 'en-US') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0.00';
  }

  try {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Math.abs(amount));
  } catch (error) {
    return Math.abs(amount).toFixed(2);
  }
};

// Get currency symbol for a given currency code
export const getCurrencySymbol = (currencyCode = 'USD') => {
  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    NGN: '₦',
    GHS: '₵',
    KES: 'KSh',
    ZAR: 'R',
    CAD: 'C$',
    AUD: 'A$',
    JPY: '¥',
    CHF: 'CHF',
    CNY: '¥',
    INR: '₹',
    BRL: 'R$',
    MXN: '$'
  };

  return currencySymbols[currencyCode] || currencyCode;
};

// Format balance with currency symbol and optional sign
export const formatBalance = (amount, currencyCode = 'USD', showSign = false) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0.00';
  }

  const symbol = getCurrencySymbol(currencyCode);
  const formattedAmount = Math.abs(amount).toFixed(2);
  const sign = showSign ? (amount >= 0 ? '+' : '-') : '';
  
  return `${sign}${symbol}${formattedAmount}`;
};
